import Loading from '@/components/Loading/Loading';
import { breakpoints } from '@/lib/collections/category/helpers';
import Slider from '@/components/slider/Slider';

const Placeholder = () => (
  <>
    <div className="relative lg:hidden">
      <Slider breakpoints={breakpoints}>
        {[1, 2, 3, 4, 5, 6].map(() => (
          <div className="flex h-[250px] w-full animate-pulse items-center justify-center rounded-md border !bg-white">
            <Loading />
          </div>
        ))}
      </Slider>
    </div>
    <div className="hidden h-full w-full grid-cols-3 gap-3 lg:grid lg:w-3/5 ">
      {[1, 2, 3, 4, 5, 6].map(() => (
        <div className="flex h-[250px] w-full animate-pulse items-center justify-center rounded-md border !bg-white">
          <Loading />
        </div>
      ))}
    </div>
  </>
);

export default Placeholder;
